<div *ngIf="currentUser" class="for-fixed-head">
    <app-header [isAdminRoute]="isAdminRoute"></app-header>
</div>
<app-usermenu *ngIf="currentUser" [currentUser]="currentUser" [isAdminRoute]="isAdminRoute"></app-usermenu>
<div class="row offset-2 col-10 p-0 main">
    <div class="col-12">
        <div>
            <router-outlet *ngIf="!isIframe"></router-outlet>
        </div>
    </div>
</div>